<template>
  <div>
  <div id="main" class="app">

    <template v-if="$route.meta.requiresAuth">
      <nav-bar />

      <div class="px-3 my-3">

      <div class="row">
        <div class="col-12">

      <template v-if="store.agency && store.agency.name">
      <div class="dropdown d-print-none">
        <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="processing">
          {{ store.agency.name }}
          <template v-if="store.agency.processing_mode">
            <span class="badge badge-pill text-uppercase bg-primary" :class="setModeClass(store.agency.processing_mode)">{{ store.agency.processing_mode }}</span>
          </template>
        </button>
        <ul class="dropdown-menu">
          <template v-for="agency in agencies">
            <li :hidden="agency.uuid === store.agency.uuid"><a class="dropdown-item" @click="switchAgency(agency)">{{ agency.name }}</a></li>
          </template>
        </ul>
      </div>
      </template>

        </div><!--Col-->

      </div><!--Row-->
      </div>
    </template>

    <div class="px-3">
      <router-view />

      <template v-if="$route.meta.requiresAuth">
        <app-alerts />
      </template>

      </div>

  </div>
</div>
</template>
<script>
export default {
    inject: ['store'],

    data() {
        return {
          processing: false,
          agency: {},
          agencies: [],
          dropdownList: []
        }
    },

    mounted() {
      // Initialize Bootstrap dropdowns
      const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
      if (dropdownElementList.length > 0) {
        const dropdownList = [...dropdownElementList].map(dropdownToggleEl => {
          return new bootstrap.Dropdown(dropdownToggleEl);
        });
        this.dropdownList = dropdownList; // Store for cleanup
      }
    },
    
    beforeUnmount() {
      // Clean up dropdown instances
      if (this.dropdownList && this.dropdownList.length > 0) {
        this.dropdownList.forEach(dropdown => {
          dropdown.dispose();
        });
      }
    },

    created() {
      this.initializeApp();
    },

    watch: {
      '$route'(to, from) {
        this.initializeApp();
      }
    },

  methods: {

    initializeApp() {
      const excludedRoutes = ['login', 'logout'];

      if(this.$route.name && !excludedRoutes.includes(this.$route.name)) {
        this.getCurrentUser();
        this.getSettings();
        this.getAgencies();
      }
    },

    getSettings() {
      this.$http.get('/settings')
      .then(response => {
        if(response && response.data) {
          this.store.agency = response.data;
          localStorage.setItem('settings', JSON.stringify(response.data));
        }
      })
    },

    getAgencies() {
      this.$http.get('/agencies?sort=name&sortDirection=asc')
      .then(response => {
        if(response && response.data) {
          this.agencies = response.data;
        }
      })
    },

    switchAgency(agency)
    {
      this.processing = true;
      this.$http.get('/settings?agency='+agency.uuid)
      .then(response => {
        if(response && response.data) {
          this.processing = false;
          //clear session storage
          sessionStorage.clear();
          window.location.reload();
        }
      })
    },

    setModeClass(value) {
      if(!value) {
        return;
      }

      if(value == 'live') {
        return 'bg-success';
      }

      return 'bg-primary';
    }

  }
}
</script>
